import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../../../Footer.styles';

var SocialAppFooter = function SocialAppFooter(_ref) {
  var socials = _ref.socials;
  return /*#__PURE__*/React.createElement(React.Fragment, null, socials.map(function (_ref2) {
    var name = _ref2.name,
        dataTest = _ref2.dataTest,
        href = _ref2.href,
        target = _ref2.target,
        icon = _ref2.icon,
        ariaLabel = _ref2.ariaLabel;
    return /*#__PURE__*/React.createElement(Styled.SocialAppLink, {
      key: name,
      "data-test": dataTest,
      href: href,
      target: target,
      "aria-label": ariaLabel
    }, icon);
  }));
};

SocialAppFooter.propTypes = {
  socials: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    dataTest: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
    icon: PropTypes.element.isRequired
  }).isRequired).isRequired
};
export default SocialAppFooter;